import store from "@/store";
import { getSystemTimestamp } from "@/api/system";

export const dateCalibration = (date, format) => {
  const D = new Date(+date);
  const result = D.toLocaleString("en-US", {
    timeZone: "Asia/Shanghai",
    weekday: format === "day" ? "short" : undefined,
    month: format === "month" ? "numeric" : undefined
  });
  if (format === "day") {
    const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return dayMap[result];
  } else if (format === "month") {
    return +result - 1;
  }
};

export const serverDate = async () => {
  if (store.state.date.correctTamp === null) {
    const result = await getSystemTimestamp();
    const correct = +result.data - new Date().getTime();
    store.dispatch("date/setCorrectTamp", correct);
  }
  const D = new Date();
  const tamp = D.getTime() + store.state.date.correctTamp;
  return tamp;
};
